import { render, staticRenderFns } from "./DoubleInsurance.vue?vue&type=template&id=23c116ce&scoped=true"
import script from "./DoubleInsurance.vue?vue&type=script&lang=js"
export * from "./DoubleInsurance.vue?vue&type=script&lang=js"
import style0 from "./DoubleInsurance.vue?vue&type=style&index=0&id=23c116ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c116ce",
  null
  
)

export default component.exports